"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sheet = exports.slotFormula = exports.perHour = exports.squash = exports.same = exports.T = void 0;
const takeoff_layout_ts_1 = require("./takeoff-layout.js");
exports.T = takeoff_layout_ts_1.SHEET.takeOff;
/** Two values this close are the same (the workbook stores doubles). */
const SAME = 1e-9;
/** A rate of 0 divides by zero in the workbook; this many per hour works out to no time at all. */
const NO_TIME = 1e12;
const same = (a, b) => b !== null && Math.abs(a - b) < SAME;
exports.same = same;
const squash = (text) => text.replace(/\s+/g, '').toLowerCase();
exports.squash = squash;
/** A rate per hour as the workbook can divide by it: 0 (the app's "no time") as NO_TIME. */
const perHour = (rate) => (rate > 0 ? rate : NO_TIME);
exports.perHour = perHour;
/** The template's two-pack slots (G12, G13) for the app's generic paints of the same name. */
const GENERIC_SLOTS = { twopacklight: 1, twopackdark: 2 };
/** Other paints take the "Other Paint" slots (K11:K13) first, then any generic slot left. */
const SLOT_PREFERENCE = [3, 4, 5, 1, 2];
/** Slot formula for a surface's material $/L: I11–I13, then M11–M13 (the template's cells). */
const slotFormula = (slot) => {
    const sell = takeoff_layout_ts_1.PAINT_SLOTS[slot].sell;
    return `$${sell[0]}$${sell.slice(1)}`;
};
exports.slotFormula = slotFormula;
/** Cells being written into one workbook, and its paint slots. */
class Sheet {
    cells = new Map();
    blocks = [];
    /** Paint id → slot (0–5); slot 0 is the option's first paint, the one sundries use. */
    slots;
    template;
    constructor(template, slots) {
        this.template = template;
        this.slots = new Map(slots);
    }
    /** An empty sheet with these paint slots, to try an area on. */
    fork() {
        return new Sheet(this.template, this.slots);
    }
    /** Give a paint a slot: the two-pack paints their own, others the "Other Paint" slots first. False when all six are taken. */
    addPaint(id) {
        if (this.slots.has(id))
            return true;
        const taken = new Set(this.slots.values());
        const own = GENERIC_SLOTS[id];
        const slot = own !== undefined && !taken.has(own) ? own : SLOT_PREFERENCE.find((s) => !taken.has(s));
        if (slot === undefined)
            return false;
        this.slots.set(id, slot);
        return true;
    }
    /** A number, written only where the template holds something else. */
    number(address, value) {
        if (!(0, exports.same)(value, this.template.num(exports.T, address)))
            this.cells.set(address, value);
    }
    /** Text, written only where the template holds something else. */
    text(address, value) {
        if (value.trim() !== this.template.text(exports.T, address))
            this.cells.set(address, value);
    }
    formula(address, formula) {
        this.cells.set(address, { formula });
    }
}
exports.Sheet = Sheet;
